"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../utils/constants");
var _upsellUtils = require("../../utils/upsellUtils");
var _AccessoryParser = require("./AccessoryParser");
const typeMap = {
  accessory: _constants.PRODUCT_TYPES.ACCESSORY,
  insurance: _constants.PRODUCT_TYPES.INSURANCE
};
const parsePricing = product => {
  return product.productOfferingPrice.map((priceItem, index) => {
    var _priceItem$productOff, _priceItem$productOff2;
    return {
      priceValue: priceItem.price.value,
      priceUnit: priceItem.price.unit,
      priceType: priceItem.priceType,
      durationAmount: (_priceItem$productOff = priceItem.productOfferingTerm[index]) === null || _priceItem$productOff === void 0 ? void 0 : _priceItem$productOff.duration.amount,
      durationUnit: (_priceItem$productOff2 = priceItem.productOfferingTerm[index]) === null || _priceItem$productOff2 === void 0 ? void 0 : _priceItem$productOff2.duration.units
    };
  }).sort((a, b) => a.priceValue - b.priceValue)[0];
};
const parseUpsellOfferings = (offerings, upsellSettings) => {
  const priceFormatedOfferings = offerings.map(offering => {
    offering.price = parsePricing(offering);
    offering.productType = typeMap[offering.category[0].name];
    const productName = offering.name;
    const productCategory = offering.category[0].id;
    const topFeaturesCharacteristics = upsellSettings.upsellTypes.find(type => {
      return type.value === productCategory;
    }).characteristics;
    const topFeaturesList = [];
    offering.productSpecification.productSpecCharacteristic.filter(characteristic => {
      const itsTopFeature = topFeaturesCharacteristics.includes(characteristic.name);
      return itsTopFeature;
    }).forEach(spec => {
      spec.productSpecCharacteristicValue.forEach(value => {
        const text = typeof value.value === 'boolean' ? `${spec.name}` : value.value;
        value.value && topFeaturesList.push(text);
      });
    });
    const priceType = offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].priceType;
    let upfrontPriceValue, recurringPriceValue, recurringPriceTerm;
    if (priceType === _constants.PRICE_TYPES.ADVANCE_PAYMENT) {
      const {
        totalPrice,
        minUpfront,
        maxTerm
      } = (0, _AccessoryParser.parsePriceOffering)(offering);
      const {
        upfront,
        monthlyPrice
      } = (0, _upsellUtils.calculateUpsellPayment)(totalPrice.value, minUpfront.value, maxTerm.value);
      upfrontPriceValue = upfront;
      recurringPriceValue = monthlyPrice;
      recurringPriceTerm = maxTerm.unitOfMeasure;
    } else {
      upfrontPriceValue = priceType === _constants.PRICE_TYPES.UP_FRONT ? offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].price.value : 0;
      recurringPriceValue = priceType === _constants.PRICE_TYPES.RECURRING ? offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].price.value : 0;
      recurringPriceTerm = priceType === _constants.PRICE_TYPES.RECURRING ? offering === null || offering === void 0 ? void 0 : offering.productOfferingPrice[0].productOfferingTerm[0].duration.units : null;
    }
    const paymentOptions = (0, _upsellUtils.createPaymentOptions)(recurringPriceValue, recurringPriceTerm, '', upfrontPriceValue);
    return {
      ...offering,
      productName,
      topFeaturesList,
      paymentOptions,
      upfrontPriceValue,
      recurringPriceValue,
      recurringPriceTerm
    };
  });
  return priceFormatedOfferings;
};
var _default = parseUpsellOfferings;
exports.default = _default;